const LocalStorageUtil = {
  set: (key: string, value: any): void => {
    const type: string = typeof value;
    localStorage.setItem(key, JSON.stringify({type, value}));
  },
  get: (key: string): any => {
    if (!import.meta.client) return null;
    const storedData: string | null = localStorage.getItem(key);
    if (!storedData) return null
    const data = JSON.parse(storedData);
    return data.value
  },
  remove: (key: string): any => {
    localStorage.removeItem(key);
  }
};

export default LocalStorageUtil;